const pageNameKey = "questionMarkWithPopoverForConditionMonitoring";

export const questionMarkWithPopoverForConditionMonitoringEn = {
  [pageNameKey]: {
    explanation: "How the join operator works:",
    descriptionAnd:
      "Choose AND if all conditions must be true to trigger the alarm.",
    descriptionOr: "Choose OR if just one condition is enough to trigger it.",
  },
};

export const questionMarkWithPopoverForConditionMonitoringPtBr = {
  [pageNameKey]: {
    explanation: "Como o operador join funciona:",
    descriptionAnd:
      "Escolha E se todas as condições precisarem ser verdadeiras para acionar o alarme.",
    descriptionOr:
      "Escolha OU se apenas uma condição for suficiente para acioná-lo.",
  },
};

export const questionMarkWithPopoverForConditionMonitoringDe = {
  [pageNameKey]: {
    explanation: "Wie der Join-Operator funktioniert:",
    descriptionAnd:
      "Wählen Sie UND, wenn alle Bedingungen erfüllt sein müssen, um den Alarm auszulösen.",
    descriptionOr:
      "Wählen Sie ODER, wenn eine einzige Bedingung ausreicht, um den Alarm auszulösen.",
  },
};

export const questionMarkWithPopoverForConditionMonitoringZhHans = {
  [pageNameKey]: {
    explanation: "连接运算符的工作原理：",
    descriptionAnd: "如果所有条件都必须为真以触发警报，请选择 AND。",
    descriptionOr: "如果只需一个条件即可触发警报，请选择 OR。",
  },
};

export const questionMarkWithPopoverForConditionMonitoringIt = {
  [pageNameKey]: {
    explanation: "Come funziona l'operatore:",
    descriptionAnd:
      "Scegli AND se tutte le condizioni devono essere vere per attivare l'allarme.",
    descriptionOr:
      "Scegli OR se è sufficiente una sola condizione per attivarla.",
  },
};

export const questionMarkWithPopoverForConditionMonitoringEs = {
  [pageNameKey]: {
    explanation: "Cómo funciona el operador de unión:",
    descriptionAnd:
      "Elige Y si todas las condiciones deben ser verdaderas para activar la alarma.",
    descriptionOr: "Elige O si basta con una sola condición para activarlo.",
  },
};

export const questionMarkWithPopoverForConditionMonitoringNl = {
  [pageNameKey]: {
    descriptionAnd:
      "Kies EN als aan alle voorwaarden moet worden voldaan om het alarm te activeren.",
    descriptionOr:
      "Kies Of als slechts één voorwaarde voldoende is om het te activeren.",
    explanation: "Hoe de join-operator werkt:",
  },
};

export const questionMarkWithPopoverForConditionMonitoringTr = {
  [pageNameKey]: {
    descriptionAnd:
      "Alarmın tetiklenmesi için tüm koşulların doğru olması gerekiyorsa VE'yi seçin.",
    descriptionOr:
      "Yalnızca bir koşulun tetiklenmesi yeterliyse VEYA'yı seçin.",
    explanation: "Birleştirme operatörü nasıl çalışır:",
  },
};
